import * as React from 'react';
import './NotificationComponent.css';

import {ClipLoader} from "react-spinners";
import {INotificationProps} from "../../containers/NotificationContainer";

class NotificationComponent extends React.PureComponent<INotificationProps> {
    constructor(props: INotificationProps) {
        super(props);
    }

    public render() {
        if (this.props.display || (this.props.loading && this.props.loggedIn)) {
            return (
                <div className="w_notification_parent" role="alert">
                    {this.props.display ? this.props.text : null}
                    <ClipLoader
                        loading={this.props.loading}
                        color="#ffffff"
                    />
                </div>
            );
        } else {
            return null;
        }
    }
}

export default NotificationComponent;



// WEBPACK FOOTER //
// ./src/components/NotificationComponent/NotificationComponent.tsx